module.exports = __webpack_public_path__ + "img/BIL.3f82818e.png";